import { useEffect, useRef, useState } from 'react';
import { useEchap } from './useEchap';
import type { SorteDEchap } from './ordreDEchap';

/**
 * Un petit menu qui s'ouvre sur un bouton et se referme tout seul : un clic ailleurs, ou
 * Échap. Le ref se pose sur l'élément qui contient le bouton ET le menu, pour qu'un clic
 * dans le menu ne le referme pas avant d'avoir été lu.
 *
 * `sorte` : sa place dans l'ordre d'Échap (`ordreDEchap`). Par défaut `pile`, il se ferme avec ce
 * qui est dessous ; `garde` pour un menu posé dans la fiche, qu'Échap referme sans fermer la fiche.
 */
export function useMenuOuvert<T extends HTMLElement = HTMLDivElement>(sorte: SorteDEchap = 'pile') {
  const [ouvert, setOuvert] = useState(false);
  const ref = useRef<T>(null);

  useEffect(() => {
    if (!ouvert) return;
    const dehors = (e: PointerEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) setOuvert(false);
    };
    document.addEventListener('pointerdown', dehors);
    return () => document.removeEventListener('pointerdown', dehors);
  }, [ouvert]);

  // Échap passe par l'écoute commune, avec l'ordre de tout ce qui est ouvert.
  useEchap(ouvert, () => setOuvert(false), sorte);

  return { ouvert, setOuvert, ref };
}
